module.exports = __webpack_public_path__ + "static/media/BA.e5c544d3.svg";